import '../../style/App.css';
import { useRef, useEffect } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import FileUpload from '../FileUpload';
import { useImages } from '../../../../../providers/ImagesProvider';
import ImageDropdown from './ImageDropdown'

const UploadMonsterImage = ({uploadIconCreature, setUploadIconCreature, setCurrentEncounter, setUploadIconMenu, uploadIconMenu, socket}) => {
    const { avatars, setAvatars } = useImages();

    const handleClose = () => {
        setUploadIconMenu(false);
    };

    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if ((ref.current && !ref.current.contains(event.target)) || event.target.tagName === 'IMG') {
                handleClose()
            }
        };

        if(uploadIconMenu) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }
        
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    // eslint-disable-next-line
    }, [uploadIconMenu]);

    const handleClick = (imageObj) => {
        const homebrew = !!uploadIconCreature?.dmb_homebrew_guid;
        const search = uploadIconCreature?.encounterGuid === undefined;
        const encounter = uploadIconCreature?.encounterGuid === null;
        let type = 'encounterHomebrew'
        if(search) {
            type = 'search'
        } else if (encounter) {
            type = 'homebrew'
        } else if (!homebrew) {
            type = 'encounter'
        }

        if(type === 'encounter' || type === 'encounterHomebrew') {
            setCurrentEncounter(prev => {
                const updatedCreatures = prev.creatures.map(creature => {
                    if (uploadIconCreature.creatureGuid === creature.creatureGuid) {
                        return {...creature, avatarUrl: imageObj.image};
                    }
                    return creature;
                });
        
                socket.emit("creatureAvatarChange", imageObj.imageGuid, uploadIconCreature.creatureGuid, "dm");
                return {...prev, creatures: updatedCreatures};
            });
        } else if(type === 'homebrew' || type === 'search') {
            setUploadIconCreature({...uploadIconCreature, avatarUrl: imageObj.image})
        }
    };

    return (
        <Dialog open={uploadIconMenu} onClose={handleClose} ref={ref} >
            <div className='avatarUploadHeader'>
                <hr className="editlineSeperator" />
                <div className='uploadImageTopInfo'>     
                    <FileUpload setUploadedFiles={setAvatars} storageKey={"avatar"} socket={socket} label={'Avatar'} hr={false}/>
                    <img src={uploadIconCreature?.avatarUrl} alt={"list Icon"} width={75} height={75} style={{border: '1px solid black'}}/>
                </div>
                <div style={{display: 'flex', flex: '1', justifyContent: 'space-between'}}>
                    Select a new icon
                    <div style={{textWrap: 'nowrap'}}><b>{uploadIconCreature?.name}</b></div>
                </div>
                <hr className='editlineSeperator'/> 
            </div>
            <DialogContent style={{padding: '5px'}}>
                <ImageDropdown title='Avatars' uploadedType={'avatar'} autoOpen={true} uploadedFiles={avatars} setUploadedFiles={setAvatars} handleClick={handleClick} socket={socket}/>
            </DialogContent> 
        </Dialog>
    );
};

export default UploadMonsterImage;